import { TbMapSearch } from "react-icons/tb";
import { BiCollection } from "react-icons/bi";
import { BsPersonVcard } from "react-icons/bs";
import { TbReportMoney } from "react-icons/tb";
import { TiLocationArrowOutline } from "react-icons/ti";
import { RiSettings4Line } from "react-icons/ri";
import { RxDashboard } from "react-icons/rx";
import { BiPurchaseTag } from "react-icons/bi";
import { BiSolidReport } from "react-icons/bi";
import { IoIosSettings } from "react-icons/io";
import { HiOutlineCash } from "react-icons/hi";
import { FaRegFileAlt, FaUsers } from "react-icons/fa";

import { LuPackage } from "react-icons/lu";
import { FiFileText } from "react-icons/fi";
import { RiShoppingCartLine } from "react-icons/ri";

export const sidebarData = [
  {
    menu: "Accounting",
    icon: <BiCollection size={16} />,
    key: "accounting",
    permissions: ["can_read_voucher_type", "can_create_voucher_type", "can_update_voucher_type"],
    sub_menu: [
      {
        name: "Voucher Type",
        link: "/voucher-type",
        permissions: ["can_read_voucher_type", "can_create_voucher_type", "can_update_voucher_type"],
      },
      {
        name: "G/L Account",
        link: "/gl-account",
        permissions: ["can_read_general_ledger", "can_create_general_ledger", "can_update_general_ledger"],
      },
      {
        name: "G/L Account Group",
        link: "/account-group",
        permissions: ["can_read_account_group", "can_create_account_group", "can_update_account_group"],
      },

      {
        name: "Voucher",
        link: "/voucher",
        permissions: ["can_read_voucher", "can_create_voucher", "can_update_voucher"],
      },
      {
        name: "Payment Voucher",
        link: "/payment-voucher",
        permissions: ["can_read_voucher", "can_create_voucher", "can_update_voucher"],
      },
      {
        name: "Recipt Voucher",
        link: "/recipt-voucher",
        permissions: ["can_read_voucher", "can_create_voucher", "can_update_voucher"],
      },
    ],
  },
  {
    menu: "Inventory",
    icon: <BiCollection size={16} />,
    key: "item",
    permissions: ["can_read_item"],
    sub_menu: [
      {
        name: "Item",
        link: "/item",
        permissions: ["can_read_item", "can_create_item", "can_update_item"],
      },
    ],
  },

  {
    menu: "Purchase A/P",
    icon: <FaUsers size={16} />,
    key: "purchase",
    permissions: ["can_read_purchase", "can_read_purchase"],
    sub_menu: [
      {
        name: "Inter Branch A/P",
        link: "/inter-branch-ap",
        childKey: "interBranchAP",
        permissions: [""],
        child_menu: [
          {
            name: "Material Request(Bran)",
            link: "/material-request",
            permissions: ["can_read_material_request", "can_create_material_request", "can_update_material_request"],
          },
          {
            name: "Pending Invoice(Branch)",
            link: "/pending-invoice-branch",
            permissions: [
              "can_read_purchase_invoice_branch",
              "can_create_purchase_invoice_branch",
              "can_update_purchase_invoice_branch",
            ],
          },
          {
            name: "Pur. Order(Branch)",
            link: "/purchase-order-branch",
            permissions: [
              "can_read_purchase_order_branch",
              "can_create_purchase_order_branch",
              "can_update_purchase_order_branch",
            ],
          },

          {
            name: "Pur. Return(Branch)",
            link: "/purchase-return-branch",
            permissions: [
              "can_read_purchase_return_branch",
              "can_create_purchase_return_branch",
              "can_update_purchase_return_branch",
            ],
          },
        ],
      },
      {
        name: "Third Party A/P",
        link: "/third-party-ap",
        childKey: "thirdPartyAP",
        permissions: [""],
        child_menu: [
          {
            name: "Purchase Order",
            link: "/purchase-order",
            permissions: ["can_read_purchase_order", "can_create_purchase_order", "can_update_purchase_order"],
          },
          {
            name: "Purchase Return",
            link: "/purchase-return",
            permissions: ["can_read_purchase_return", "can_create_purchase_return", "can_update_purchase_return"],
          },

          {
            name: "GRN",
            link: "/grn",
            permissions: ["can_read_grn", "can_create_grn", "can_update_grn"],
          },
          {
            name: "GRN Additional Invoice",
            link: "/grn-invoice",
            permissions: ["can_read_grn_invoice", "can_create_grn_invoice", "can_update_grn_invoice"],
          },

          {
            name: "Purchase Invoice",
            link: "/purchase-invoice",
            permissions: ["can_read_purchase_invoice", "can_create_purchase_invoice", "can_update_purchase_invoice"],
          },
          {
            name: "Purchase Debit Note",
            link: "/purchase-debit-note",
            permissions: [
              "can_read_purchase_debit_note",
              "can_create_purchase_debit_note",
              "can_update_purchase_debit_note",
            ],
          },
          {
            name: "Purchase Credit Note",
            link: "/purchase-credit-note",
            permissions: [
              "can_read_purchase_credit_note",
              "can_create_purchase_credit_note",
              "can_update_purchase_credit_note",
            ],
          },
        ],
      },
    ],
  },
  {
    menu: "Sales A/R",
    icon: <RiShoppingCartLine size={16} />,
    key: "sales",
    permissions: ["can_read_customer", "can_read_supplier"],
    sub_menu: [
      {
        name: "Inter Branch A/R",
        link: "/inter-branch-ar",
        childKey: "interBranchAR",
        permissions: [""],
        child_menu: [
          {
            name: "Sale Request",
            link: "/sale-request",
            permissions: [
              "can_read_sale_request_order",
              "can_create_sale_request_order",
              "can_update_sale_request_order",
            ],
          },

          {
            name: "Sale Order Branch",
            link: "/sale-order-branch",
            permissions: [
              "can_read_sale_invoice_branch",
              "can_create_sale_invoice_branch",
              "can_update_sale_invoice_branch",
            ],
          },
          {
            name: "Sale Return(Branch)",
            link: "/sale-return-branch",
            permissions: [
              "can_read_sale_return_branch",
              "can_create_sale_return_branch",
              "can_update_sale_return_branch",
            ],
          },
        ],
      },
      {
        name: "Third Party A/R",
        link: "/third-party-ar",
        childKey: "thirdPartyAR",
        permissions: [""],
        child_menu: [
          {
            name: "Sale Order",
            link: "/sale-order",
            permissions: ["can_read_sale_order", "can_create_sale_order", "can_update_sale_order"],
          },
          {
            name: "Delivery Note",
            link: "/delivery-note",
            permissions: ["can_read_delivery_note", "can_create_delivery_note", "can_update_delivery_note"],
          },
          {
            name: "Sale Invoice",
            link: "/sale-invoice",
            permissions: ["can_read_sale_invoice", "can_create_sale_invoice", "can_update_sale_invoice"],
          },
          {
            name: "Sale Return",
            link: "/sale-return",
            permissions: ["can_read_sale_return", "can_create_sale_return", "can_update_sale_return"],
          },
          {
            name: "Sale",
            link: "/sale",
            permissions: ["can_read_sale", "can_create_sale", "can_update_sale"],
          },
          {
            name: "Sale Debit Note",
            link: "/sale-debit-note",
            permissions: ["can_read_sale_debit_note", "can_create_sale_debit_note", "can_update_sale_debit_note"],
          },
          {
            name: "Sale Credit Note",
            link: "/sale-credit-note",
            permissions: ["can_read_sale_credit_note", "can_create_sale_credit_note", "can_update_sale_credit_note"],
          },
        ],
      },
    ],
  },

  {
    menu: "Party Management",
    icon: <FaUsers size={16} />,
    key: "party",
    permissions: ["can_read_customer", "can_read_supplier"],
    sub_menu: [
      {
        name: "Customer",
        link: "/customer",
        permissions: ["can_read_customer", "can_create_customer", "can_update_customer"],
      },

      {
        name: "Party",
        link: "/party",
        permissions: ["can_read_party", "can_create_party", "can_update_party"],
      },
    ],
  },
  {
    menu: "Cost Center",
    icon: <FaUsers size={16} />,
    key: "Cost Center",
    permissions: ["can_read_customer", "can_read_supplier"],
    sub_menu: [
      {
        name: "Dimension",
        link: "/dimension",
        permissions: ["can_read_customer", "can_create_customer", "can_update_customer"],
      },

      {
        name: "Cost Center Type",
        link: "/cost-center-type",
        permissions: ["can_read_party", "can_create_party", "can_update_party"],
      },
      {
        name: "Cost Center",
        link: "/cost-center",
        permissions: ["can_read_party", "can_create_party", "can_update_party"],
      },
      {
        name: "Cost Center Report",
        link: "/cost-center-report",
        permissions: ["can_read_cost_center_report", "can_create_cost_center_report", "can_update_cost_center_report"],
      },
    ],
  },
  {
    menu: "Additional Costs & Charges",
    icon: <HiOutlineCash size={16} />,
    key: "additional-cost-and-charges",
    permissions: ["can_read_customer", "can_read_supplier"],
    sub_menu: [
      {
        name: "Additional Charge",
        link: "/additional-charge",
        permissions: ["can_read_additional_cost", "can_create_additional_cost", "can_update_additional_cost"],
      },
      {
        name: "Charge Status",
        link: "/charge-status",
        permissions: ["can_read_grn_charges_status", "can_create_grn_charges_status", "can_update_grn_charges_status"],
      },
      {
        name: "GRN Additional Cost",
        link: "/grn-additional-cost",
        permissions: [
          "can_read_grn_additional_charge",
          "can_create_grn_additional_charge",
          "can_update_grn_additional_charge",
        ],
      },
    ],
  },
  {
    menu: "Common Pages",
    icon: <FiFileText size={16} />,
    key: "common-pages",
    permissions: [
      "can_read_base_unit",
      "can_read_brand",
      "can_read_category",
      "can_read_colour",
      "can_read_company",
      "can_read_flavour",
      "can_read_groups",
      "can_read_type",
      "can_read_shape",
      "can_read_customer_type",
      "can_read_payment_type",
      "can_read_voucher_type",
    ],
    sub_menu: [
      {
        name: "Base Unit",
        link: "/product/base-unit",
        permissions: ["can_read_base_unit", "can_create_base_unit", "can_update_base_unit"],
      },
      {
        name: "Brand",
        link: "/product/brand",
        permissions: ["can_read_brand", "can_create_brand", "can_update_brand"],
      },
      {
        name: "Category",
        link: "/product/category",
        permissions: ["can_read_category", "can_create_category", "can_update_category"],
      },
      {
        name: "Colour",
        link: "/product/colour",
        permissions: ["can_read_colour", "can_create_colour", "can_update_colour"],
      },
      {
        name: "Company",
        link: "/product/company",
        permissions: ["can_read_company", "can_create_company", "can_update_company"],
      },

      {
        name: "Flavour",
        link: "/product/flavour",
        permissions: ["can_read_flavour", "can_create_flavour", "can_update_flavour"],
      },
      {
        name: "Groups",
        link: "/product/groups",
        permissions: ["can_read_groups", "can_create_groups", "can_update_groups"],
      },
      {
        name: "Type",
        link: "/product/type",
        permissions: ["can_read_type", "can_create_type", "can_update_type"],
      },
      {
        name: "Shape",
        link: "/product/shape",
        permissions: ["can_read_shape", "can_create_shape", "can_update_shape"],
      },
      {
        name: "Customer Type",
        link: "/customer/customer-type",
        permissions: ["can_read_customer_type", "can_create_customer_type", "can_update_customer_type"],
      },
      {
        name: "Payment Mode",
        link: "/customer/payment-mode",
        permissions: ["can_read_payment_mode", "can_create_payment_mode", "can_update_payment_mode"],
      },
      {
        name: "Payment Type",
        link: "/customer/payment-type",
        permissions: ["can_read_payment_type", "can_create_payment_type", "can_update_payment_type"],
      },
    ],
  },

  {
    menu: "Stock",
    icon: <LuPackage size={16} />,
    key: "stock",
    permissions: ["can_read_stock", "can_read_stock"],
    sub_menu: [
      {
        name: "Stock Analysis",
        link: "/stock-analysis",
        permissions: ["can_read_stock", "can_create_stock", "can_update_stock"],
      },
    ],
  },
  {
    menu: "Reports",
    icon: <FaRegFileAlt size={16} />,
    key: "report",
    permissions: ["can_read_ledger_report", "can_read_product_report"],
    sub_menu: [
      {
        name: "Ledger Report",
        link: "/account-ledger-report",
        permissions: ["can_read_ledger_report"],
      },
      {
        name: "Product Report",
        link: "/product-ledger-report",
        permissions: ["can_read_product_report"],
      },
    ],
  },
  {
    menu: "Api Logs",
    icon: <LuPackage size={16} />,
    key: "api-logs",
    permissions: [],
    sub_menu: [
      {
        name: "Api Logs",
        link: "/api-logs",
        permissions: [],
      },
    ],
  },
];

export const admin = [
  {
    menu: "Setting",
    icon: <RiSettings4Line size={18} />,
    permissions: ["can_read_organization", "can_read_user", "can_read_user_group"],
    key: "setting",
    sub_menu: [
      {
        name: "System Setup",
        link: "/system-setup",
        childKey: "coreSetup",
        permissions: ["can_read_organization"],
        child_menu: [
          {
            name: "Organization",
            link: "/organization-setup",
            permissions: ["can_read_organization", "can_create_organization", "can_update_organization"],
          },
          {
            name: "Base Document Rule",
            link: "/base-document-rule",
            permissions: [
              "can_read_base_document_rule",
              "can_create_base_document_rule",
              "can_update_base_document_rule",
            ],
          },
          // {
          //   name: "Branch Permission",
          //   link: "/branch-permission",
          //   permissions: [""],
          // },
          {
            name: "Branch Role",
            link: "/branch-role",
            permissions: [""],
          },
          {
            name: "Role",
            link: "/role",
            permissions: [""],
          },
          {
            name: "Department",
            link: "/department",
            permissions: ["can_read_department", "can_create_department", "can_update_department"],
          },
          {
            name: "Branch",
            link: "/branch",
            permissions: ["can_read_branch", "can_create_branch", "can_update_branch"],
          },
          {
            name: "Freight",
            link: "/freight",
            permissions: ["can_read_freight", "can_create_freight", "can_update_freight"],
          },
          {
            name: "Currency",
            link: "/currency",
            permissions: ["can_read_currency", "can_read_currency", "can_update_area"],
          },
          {
            name: "Doc. Series",
            link: "/document-series",
            permissions: ["can_read_documentSeries", "can_read_documentSeries", "can_update_documentSeries"],
          },
          {
            name: "Doc. Numbering",
            link: "/document-numbering",
            permissions: ["can_read_documentNumbering", "can_read_documentNumbering", "can_update_documentNumbering"],
          },
        ],
      },

      {
        name: "Region Setup",
        // link: "/palika",
        childKey: "regionSetup",
        permissions: [
          "can_read_country",
          "can_read_country",
          "can_update_country",
          "can_read_province",
          "can_read_province",
          "can_update_province",
          "can_read_district",
          "can_create_district",
          "can_update_district",
          "can_read_palika",
          "can_create_palika",
          "can_update_palika",
          "can_read_area",
          "can_read_area",
          "can_update_area",
        ],
        child_menu: [
          {
            name: "Country",
            link: "/country",
            permissions: ["can_read_country", "can_read_country", "can_update_country"],
          },

          {
            name: "Province",
            link: "/province",
            permissions: ["can_read_province", "can_read_province", "can_update_province"],
          },
          {
            name: "District",
            link: "/district",
            permissions: ["can_read_district", "can_create_district", "can_update_district"],
          },
          {
            name: "Palika",
            link: "/palika",
            permissions: ["can_read_palika", "can_create_palika", "can_update_palika"],
          },
          {
            name: "Ward",
            link: "/ward",
            permissions: ["can_read_ward", "can_create_ward", "can_update_ward"],
          },
          {
            name: "Area",
            link: "/area",
            permissions: ["can_read_area", "can_read_area", "can_update_area"],
          },
        ],
      },
      {
        name: "User Setup",
        link: "/user-setup",
        childKey: "userSetup",
        permissions: ["can_read_user", "can_read_customgroup"],
        child_menu: [
          {
            name: "User",
            link: "/user",
            permissions: ["can_update_user", "can_read_user", "can_create_user"],
          },
          {
            name: "User Group",
            link: "/user-group",
            permissions: ["can_create_customgroup", "can_read_customgroup", "can_update_customgroup"],
          },
        ],
      },
    ],
  },
];
